const radios = document.querySelectorAll('.js-radio')

radios.forEach(function(radio) {
    radio.addEventListener('change', function(e) {
        const grids = document.querySelectorAll('.js-grid')

        for (const grid of grids) {
            grid.dataset.columns = e.target.value
            Cookies.set('columns', e.target.value)
        }
    })
})

const columns = Cookies.get('columns')

if (columns) {
    document.querySelector(`.js-radio[value="${columns}"]`)?.click()
} else {
    document.querySelector(`.js-radio[value="4"]`)?.click()
}